<template>
    <v-fab
        class="agent-button"
        icon="icon-stars"
        color="#3FB8D7"
        size="x-small"
        :style="style"
        @click="chatOpen = !chatOpen"
    />
    <AgentChat
        v-if="chatOpen"
        v-model="chatOpen"
    />
</template>

<script setup lang="ts">
import { computed, ref, type StyleValue, watch } from 'vue';

import AgentChat from '../agentChat/AgentChat.vue';

import { type Languages, useTranslations } from '../../composables';

export interface AgentButtonProps {
    language: Languages;
};

const props = defineProps<AgentButtonProps>();

const { languageCode } = useTranslations();

const chatOpen = ref(false);

const style = computed((): StyleValue => {
    let right = 12;
    if (import.meta.env.VITE_ENABLE_BETA === 'true') {
        right += 36;
    }
    if (import.meta.env.VITE_ENABLE_REPORT === 'true') {
        right += 36;
    }
    return {
        '--right': `${right}px`
    };
});

watch(() => props.language, (): void => {
    languageCode.value = props.language;
}, { immediate: true });
</script>

<style scoped lang="scss">
@use 'AgentButton.scss';
</style>